import { render, staticRenderFns } from "./QuizTeacherDescription.vue?vue&type=template&id=5413e9db&"
import script from "./QuizTeacherDescription.vue?vue&type=script&lang=js&"
export * from "./QuizTeacherDescription.vue?vue&type=script&lang=js&"
import style0 from "./QuizTeacherDescription.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports